import React from 'react';
import './globalLight.css';
import { toggleThemeStylesheet } from '../toggleThemeStylesheet';

class LightTheme extends React.Component {
  componentDidMount() {
    toggleThemeStylesheet('unmountableLightStylesheet', false);
  }
  componentWillUnmount() {
    toggleThemeStylesheet('unmountableLightStylesheet', true);
  }
  render() {
    return <></>;
  }
}

export default LightTheme;
